var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRoasterCountries } from '../../hooks/useRoasterCountries';
import CheckboxGroup from '../atoms/CheckboxGroup';
var RoasterCountryCheckboxGroup = function (_a) {
    var onLoaded = _a.onLoaded, props = __rest(_a, ["onLoaded"]);
    var t = useTranslation().t;
    var _b = useRoasterCountries({ onLoaded: onLoaded }), loading = _b.loading, roasterCountries = _b.roasterCountries;
    var items = React.useMemo(function () {
        return roasterCountries
            .map(function (_a) {
            var id = _a.id, code = _a.code;
            return ({
                label: t("countries.".concat(code)),
                value: id,
            });
        })
            .sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [t, roasterCountries]);
    if (loading)
        return React.createElement(CircularProgress, null);
    return React.createElement(CheckboxGroup, __assign({ items: items }, props));
};
export default RoasterCountryCheckboxGroup;
